export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
  ZAR = 'ZAR',
  TK = 'tk',
  CHF = 'CHF'
}
